import React, {useState} from "react";
import Typography from "@mui/material/Typography";
import {Accordion, AccordionSummary, Grid2, Link} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";
import {OrderAdminDTO} from "../societyAdmin/societyAdminOrders/SocietyAdminOrders";
import Box from "@mui/material/Box";
import AdminOrdersDetailsModal from "../societyAdmin/societyAdminOrders/adminOrderDetailsModal/AdminOrdersDetailsModal";
import useDataFetch from "../../hooks/useDataFetch";

export interface UserOrdersBySociety {
    societyName: string,
    orders: OrderAdminDTO[],
}

const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
};

const UserOrders = () => {

    const [selectedOrder, setSelectedOrder] = useState<OrderAdminDTO | undefined>(undefined);

    const [openAdminOrdersDetailsModal, setOpenAdminOrdersDetailsModal] = useState<boolean>(false);

    const {data: userOrders} = useDataFetch<UserOrdersBySociety>(`/user-orders`, true, true);

    const handleClickOrder = (order: OrderAdminDTO) => {
        setSelectedOrder(order);
        setOpenAdminOrdersDetailsModal(true);
    }

    const formatOrderTitle = (order: OrderAdminDTO): string => {
        return `Commande #${order.id} - ${new Date(order.createdAt).toLocaleDateString('fr-FR', defaultOptions)}`;
    }

    return (
        <>
            <Typography
                variant={"secondVariant"}
                sx={{
                    fontSize: {xs: 25, sm: 30}
                }}
            >
                Commandes
            </Typography>

            <Box padding={4}>

                <Typography
                    variant={"secondVariant"}
                    textAlign={"left"}
                    sx={{
                        fontSize: {xs: 14, sm: 16},
                        mb: 4
                    }}
                >
                    Les commandes que vous avez passées sur toutes les sociétés inscrites chez Looty sont affichées ici.
                </Typography>

                {userOrders && userOrders.map((userOrdersBySociety: UserOrdersBySociety) => {
                    return (
                        <Accordion key={userOrdersBySociety.societyName} sx={{marginBottom: '30px'}}>
                            <AccordionSummary
                                expandIcon={<ExpandMore/>}
                                aria-controls="panel1-content"
                                id="panel1-header"
                            >
                                <Typography
                                    variant={"secondVariant"}
                                    component="span"
                                    fontSize={{xs: '16px', sm: '18px'}}
                                >
                                    {userOrdersBySociety.societyName}
                                </Typography>
                            </AccordionSummary>
                            <Grid2 container pl={2} pr={2}>

                                {userOrdersBySociety.orders.map((order) => {
                                    return (

                                        <Grid2 size={12} key={order.id} mb={3}>
                                            <Link
                                                variant={"firstVariant"}
                                                textAlign={"left"}
                                                href={"#"}
                                                fontSize={{xs: "13px", sm: '15px'}}
                                                onClick={() => handleClickOrder(order)}
                                                width={"100%"}
                                            >
                                                {formatOrderTitle(order)}
                                            </Link>
                                        </Grid2>
                                    )
                                })}
                            </Grid2>

                        </Accordion>
                    )
                })}
            </Box>

            {selectedOrder && (
                <AdminOrdersDetailsModal open={openAdminOrdersDetailsModal} setOpen={setOpenAdminOrdersDetailsModal}
                                         order={selectedOrder}/>
            )}

        </>
    );
}

export default UserOrders